import React, {Component} from 'react';
import '../App.css';
import ReactAutocomplete from 'react-autocomplete'

export default class InputField extends Component {
    constructor (props) {
        super(props);
        this.state = {
            value: '',
        };
    }

    render() {
        return (
            <ReactAutocomplete
                items={this.props.items}
/*
                items={[
                    { id: 'foo', label: 'foo' },
                    { id: 'bar', label: 'bar' },
                    { id: 'baz', label: 'baz' },
                ]}
*/
                shouldItemRender={(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1}
                getItemValue={item => item.label}
                renderItem={(item, highlighted) =>
                    <div
                        key={item.id}
                        style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}
                    >
                        {item.label}
                    </div>
                }
                value={this.state.value}
                onChange={e => {
                    let val = e.target.value;
                    this.setState({value: val});
                    for (let i = 0; i < this.props.items.length; i++) {
                        if (this.props.items[i].label === val) {
                            this.props.handleChange(this.props.items[i].id);
                            break;
                        }
                    }
                }}
                onSelect={(value, item) => {
                    this.setState({value});
                    this.props.handleChange(item.id);
                }}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/inputField.js